import { JsonObject, JsonProperty } from "json2typescript";

@JsonObject("SubjectAreas")
export class SubjectArea {
    @JsonProperty("area_code", String)
    public area_code: string = ""

    @JsonProperty("area_name", String)
    public area_name: string = ""
}

@JsonObject("CitationScore")
export class CitationScore {
    @JsonProperty("latest_complete_year", String)
    public latest_complete_year: string = "";

    @JsonProperty("score_latest_complete_year", String)
    public score_latest_complete_year: string = "";

    @JsonProperty("current_year", String)
    public current_year: string = ""

    @JsonProperty("score_current_year", String)
    public score_current_year: string = ""
}

export class SJR {
    @JsonProperty("year", Number)
    public year: number = 0;

    @JsonProperty("score", String)
    public score: string = "";
}


@JsonObject("SourceDetail")
export class SourceDetail {

    @JsonProperty("publisher", String)
    public publisher: string = "";     

    @JsonProperty("issn", String)
    public issn: string = "";

    @JsonProperty("eissn", String)
    public eissn: string = "";

    @JsonProperty("subject_areas", [])
    public subject_areas: SubjectArea[] = [];

    @JsonProperty("citation_score", CitationScore)
    public citation_score: CitationScore = new CitationScore;

    @JsonProperty("sjr",[])
    public sjr: SJR[] = []

    @JsonProperty("scopus_source_link", String)
    public scopus_source_link: string = ""

    @JsonProperty("source_link", String)
    public source_link: string = ""
}




// WEBPACK FOOTER //
// ./src/models/SourceDetail.ts